import React, { useEffect, useState } from "react";

import { ReactComponent as HomeIcon } from "../images/navbar/home.svg";
// import { ReactComponent as ArchiveIcon } from "../images/navbar/archive.svg";
import { ReactComponent as WikiIcon } from "../images/navbar/wiki.svg";
import { ReactComponent as PlacesIcon } from "../images/navbar/place.svg";
import { ReactComponent as SideBarIcon } from "../images/navbar/sidebar.svg";
import { Link, useHistory } from "react-router-dom";
// import { tourGuideSteps } from "./../constant/helper";
// import Tour from "reactour";

function Navbar() {
  const [activeIndex, setActiveIndex] = useState(ActivePage.home);
  const [indicatorRightPos, setIndicatorRightPos] = useState(26);
  let history = useHistory();

  function changeActiveIndex(page) {
    if (page === "wiki" || page === "/wiki") {
      localStorage.setItem("wiki", []);
    }
    if (page.startsWith("/")) {
      const detectedRoute = ActivePage[page.substring(1)];
      if (detectedRoute) setActiveIndex(page.substring(1));
    } else {
      setActiveIndex(page);
    }
  }

  // eslint-disable-next-line
  function calcIndicatorRightPos() {
    const iconHolder = document.getElementById(`icons_${activeIndex}`);
    if (iconHolder) {
      const svgElement = iconHolder.getElementsByTagName("svg")[0];
      const svgPos = svgElement.getBoundingClientRect();
      const bodyPos = document.body.getBoundingClientRect();
      const indicatorWillPos = bodyPos.right - (svgPos.right + 10);
      setIndicatorRightPos(indicatorWillPos);
    }
  }

  useEffect(() => {
    const pathname = history.location.pathname;
    changeActiveIndex(pathname);
  }, [history.location.pathname]);

  useEffect(() => {
    const resizeListener = () => {
      // change width from the state object
      calcIndicatorRightPos();
    };
    // set resize listener
    window.addEventListener("resize", resizeListener);

    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener("resize", resizeListener);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    calcIndicatorRightPos();
  }, [activeIndex, calcIndicatorRightPos]);

  const Item = ({ index, icon }) => {
    return (
      <Link
        to={`/${index}`}
        id={`icons_${index}`}
        className={`item icons_${index} ${
          activeIndex === ActivePage[index] ? "active" : ""
        }`}
        onClick={() => {
          changeActiveIndex(ActivePage[index]);
        }}
      >
        {icon && icon}
      </Link>
    );
  };

  // const closeTourGuid = () => {
  //   localStorage.setItem("not-first-usage", JSON.stringify(true));
  //   setIsTourOpen(false);
  // };

  return (
    <>
      <div id="wrap-navbar" className={`${activeIndex}-page`}>
        <div className={`indicator`} style={{ right: indicatorRightPos }}>
          <div className="indicator_bottom" />
        </div>

        <div className="icons">
          {/* <Item index={ActivePage.archive} icon={<ArchiveIcon />} /> */}
          <Item index={ActivePage.home} icon={<HomeIcon />} />
          <Item index={ActivePage.wiki} icon={<WikiIcon />} />
          <Item index={ActivePage.lbs} icon={<PlacesIcon />} />
          <Item index={ActivePage.menu} icon={<SideBarIcon />} />
        </div>
      </div>
      {/*{!notFirstUsage && (*/}
      {/*  <Tour*/}
      {/*    steps={tourGuideSteps(setIsTourOpen)}*/}
      {/*    isOpen={isTourOpen}*/}
      {/*    onRequestClose={() => closeTourGuid()}*/}
      {/*    showButtons={false}*/}
      {/*    showNavigationNumber={false}*/}
      {/*    showNumber={false}*/}
      {/*    closeWithMask={true}*/}
      {/*    showCloseButton={false}*/}
      {/*    disableInteraction={true}*/}
      {/*    highlightedMaskClassName=""*/}
      {/*  />*/}
      {/*)}*/}
    </>
  );
}

const ActivePage = {
  home: "home",
  archive: "archive",
  wiki: "wiki",
  lbs: "lbs",
  menu: "menu",
};

export default Navbar;
